import { EventBus } from '@/plugins/eventBus';

export default EventBus();
